import { NavigationModal } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import { useTranslation } from 'react-i18next'

type DeleteFundingTypeModalProps = {
  showModal: boolean
  setShowModal: (value: boolean) => void
}

const DeleteFundingTypeModal = ({
  showModal,
  setShowModal
}: DeleteFundingTypeModalProps) => {
  const { t } = useTranslation()

  return (
    <NavigationModal
      modalTitle={t('DELETE_FUNDING_TYPE_TITLE')}
      modalContentText={t('DELETE_FUNDING_TYPE_DESCRIPTION')}
      modalConfirmText={t('OK')}
      showPrompt={showModal}
      confirmNavigation={() => setShowModal(false)}
      cancelNavigation={() => setShowModal(false)}
      confirmButtonProps={{ variant: 'primary' }}
    >
      <Text>{t('DELETE_FUNDING_TYPE_EXTRA')}</Text>
    </NavigationModal>
  )
}

export default DeleteFundingTypeModal
